import {dashboardService} from '../../services/service-factory';

export default {
  data: function() {
    return {
      dashboardService: undefined
    };
  },
  created: function() {
    this.dashboardService = dashboardService;
  }
};
